'use strict';

var SystemStatusFlightReoptController = function SystemStatusFlightReoptController($scope, systemStatusCommonRendererFactory) {
  $scope.customRenderers = systemStatusCommonRendererFactory;
};
SystemStatusFlightReoptController.$inject = ['$scope', 'SystemStatusCommonRendererFactory'];
module.exports = SystemStatusFlightReoptController;